import React from 'react'

export const FooterError = ({error}) => {
  return (
    <div className='text-danger fw-bold'>
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      <span className="ms-2">{error}</span>
    </div>
  )
}
